import { render, staticRenderFns } from "./newEstoque.vue?vue&type=template&id=6bd254b2&scoped=true&"
import script from "./newEstoque.vue?vue&type=script&lang=js&"
export * from "./newEstoque.vue?vue&type=script&lang=js&"
import style0 from "./newEstoque.vue?vue&type=style&index=0&id=6bd254b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd254b2",
  null
  
)

export default component.exports